// Marketplace option lists, label maps, and formatting helpers.
// AU/NZ-first: currency AUD/NZD, state/territory regions, metric units
// (wheel diameter/width in inches by convention, offset/PCD/bore in mm).
// Ported verbatim from app/constants/marketplace.js so web + app stay in sync.

export const WHEELS_DEPARTMENT_SLUG = 'wheels-and-tires';

export const CONDITIONS = [
  { value: 'new', label: 'New' },
  { value: 'like_new', label: 'Like new' },
  { value: 'used', label: 'Used' },
  { value: 'remanufactured', label: 'Remanufactured' },
  { value: 'for_parts', label: 'For parts / not working' },
];

export const PART_TIERS = [
  { value: 'oem', label: 'OEM' },
  { value: 'genuine', label: 'Genuine (OE)' },
  { value: 'aftermarket', label: 'Aftermarket' },
  { value: 'performance', label: 'Performance' },
  { value: 'reproduction', label: 'Reproduction' },
];

export const ROAD_LEGALITY = [
  { value: 'street', label: 'Street legal' },
  { value: 'track_offroad', label: 'Off-road / track only' },
  { value: 'show', label: 'Show use only' },
];

export const SOLD_AS = [
  { value: 'single', label: 'Single' },
  { value: 'pair', label: 'Pair' },
  { value: 'set_of_4', label: 'Set of 4' },
  { value: 'set_of_5', label: 'Set of 5' },
];

export const SORT_OPTIONS = [
  { value: 'newest', label: 'Newest' },
  { value: 'price_asc', label: 'Price: low to high' },
  { value: 'price_desc', label: 'Price: high to low' },
  { value: 'most_saved', label: 'Most saved' },
];

export const COUNTRIES = [
  { value: 'AU', label: 'Australia' },
  { value: 'NZ', label: 'New Zealand' },
];

export const AU_REGIONS = ['NSW', 'VIC', 'QLD', 'WA', 'SA', 'TAS', 'ACT', 'NT'];
export const NZ_REGIONS = [
  'Auckland', 'Wellington', 'Canterbury', 'Waikato', 'Bay of Plenty', 'Otago',
  'Manawatū-Whanganui', 'Northland', 'Hawke’s Bay', 'Taranaki', 'Southland',
  'Nelson', 'Tasman', 'Marlborough', 'Gisborne', 'West Coast',
];

// Common bolt patterns (lugs x PCD-mm), AU/NZ-weighted with the most common first.
export const BOLT_PATTERNS = [
  '5x114.3', '5x100', '5x112', '5x120', '4x100', '6x139.7',
  '5x110', '5x115', '5x108', '4x114.3', '4x108', '4x110',
  '5x105', '5x118', '5x120.65', '5x127', '5x130', '5x139.7', '5x150',
  '6x114.3', '6x120', '6x127', '6x132', '8x165.1', '8x170',
];

export const WHEEL_DIAMETERS = [14, 15, 16, 17, 18, 19, 20, 21, 22, 24];
export const WHEEL_WIDTHS = [6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12, 13];

const toMap = (arr) => arr.reduce((m, o) => { m[o.value] = o.label; return m; }, {});
export const CONDITION_LABELS = toMap(CONDITIONS);
export const TIER_LABELS = toMap(PART_TIERS);
export const ROAD_LEGALITY_LABELS = toMap(ROAD_LEGALITY);
export const SOLD_AS_LABELS = toMap(SOLD_AS);

// DECIMAL columns come back from Postgres as strings — always coerce.
export const money = (v, currency) => {
  const n = Number(v || 0);
  if (!isFinite(n)) return '';
  const [int, dec] = Math.abs(n).toFixed(2).split('.');
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const cents = dec === '00' ? '' : `.${dec}`;
  const sym = currency === 'NZD' ? 'NZ$' : '$';
  return `${n < 0 ? '-' : ''}${sym}${grouped}${cents}`;
};

export const regionsForCountry = (country) => (country === 'NZ' ? NZ_REGIONS : AU_REGIONS);
